import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { IEndUserNormsCount } from '@components/dashboard/components/summaryDetails';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';
import { useCMDIStore } from '@store/cmdiFilterStore';

export const useEndUserNormsCount = (): IQueryResponse<IEndUserNormsCount> => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');
	const userRole = profile[0]?.usertype_c;
	const { selectedCMDI } = useCMDIStore();
	const isRBDM = userRole === 'RBDM';
	const apiEndpoint = isRBDM ? APICONFIG.END_USER_NORMS_COUNT_RBDM : APICONFIG.END_USER_NORMS_COUNT;

	const payload: Record<string, string> = {};

	if (isRBDM) {
		if (selectedCMDI) {
			payload.cmdi_code = selectedCMDI;
		}
	} else {
		if (profile[0]?.divisionid_c) {
			payload.divisioncode_c = '' + profile[0].divisionid_c;
		}
		if (profile[0]?.salesgroupid_c) {
			payload.salesgroupcode_c = profile[0].salesgroupid_c;
		}
	}

	const fetchEndUserNormsCount = async (): Promise<IEndUserNormsCount> => {
		return await APIService.getData<IEndUserNormsCount>(apiEndpoint, payload);
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['endUserNormsCount', userRole, selectedCMDI],
		queryFn: fetchEndUserNormsCount,
		enabled: profile.length !== 0,
		refetchOnWindowFocus: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
